import { Box, Typography } from "@mui/material"
import SelectActionPlan from "../../../../../actionPlans/pages/main/components/selectActionPlan"
import { itemTypeScheduling } from "../../../form/components/steps/configCalendar/methods"
import { CustomSelect } from "../../../../../../components"
import { FrequencyEnum, ScheduleEnumType, SerieEnumText } from "../../../form/components/steps/configCalendar/enums"
import { icons } from "../../../../../../utils/icons"
import { InputModel } from "../../../../../../utils/types"
import { useTranslation } from "react-i18next"
import { PropsConfigSerie } from "./types"
import { useStyles } from "./styles"
import { DateModalRange } from "../../../../../../components/dinamicForm/dateModal"
import { FrecuencyInput } from "../../../form/components/steps/frecuencyInput"
import { Constants } from "../../../../../../utils/constants"
import { useEffect, useMemo, useState } from "react"
import { SerieInput } from "../serieInput"
import { daysOfWeek, frequencies, frequenciesWithOuytUnique, inputOneDaily, inputOneWeekly, inputSecondCycli, inputSecondDaily } from "../../../form/constans/inputs"

const ScheduleTypeSerie = ({ onChange, selectedDays, setData, maxToDay, setSelectedDays, setStartDate, data, errors, mimTimeZone, refRange, startDate, scheduleType, }: PropsConfigSerie) => {
    const { t } = useTranslation()
    const styles = useStyles()

    const [inputSecondWeekly, setInputSecondWeekly] = useState<{ [x: string]: InputModel }>({
        dayOfWeek: {
            label: 'general.tags.each',
            translate: true,
            name: 'dayOfWeek',
            type: 'select',
            value: null,
            items: daysOfWeek,
            rest: {
                max: 'to',
            },
            validate: {
                required: true,
            },
            size: {
                xl: 12,
                lg: 12,
                md: 12,
                sm: 12,
            },
            wrapChildren: ({ children, id }) => {
                return (<>
                    <Box sx={{ minHeight: '70px', alignContent: 'center' }}>
                        <Box sx={{
                            '& .MuiInputBase-root': {
                                height: '70px',
                            },
                            '& .MuiFormLabel-root': {
                                top: '8px'
                            }
                        }}>{children}</Box>
                    </Box>
                </>
                )
            }
        },
    })

    const getFrecuencyInputs = () => {
        let caseFrequency = <></>
        switch (data.frequency) {
            case FrequencyEnum.CYCLIC:
                caseFrequency =
                    <FrecuencyInput
                        endDateName="endDate"
                        endDateNameButton={t('general.tags.closingTime')}
                        endFromName="toDateCycli"
                        endFromNameButton={t('general.tags.to')}
                        startDateName="startDate"
                        startDateNameButton={t('general.tags.openingTime')}
                        startFromName="fromDateCycli"
                        startFromNameButton={t('general.tags.from')}
                        mimTimeZone={mimTimeZone}
                        refRange={refRange}
                        startDate={startDate}
                        selectedsDays={selectedDays}
                        setSelectedDays={setSelectedDays}
                        type={data.frequency}
                        data={data}
                        errors={errors}
                        input={inputOneWeekly}
                        inputSecond={inputSecondCycli}
                        onChange={onChange}
                    />
                break
            case FrequencyEnum.DAYLI:
                caseFrequency =
                    <FrecuencyInput
                        endDateName="endDateDaily"
                        endDateNameButton={t('general.tags.endHour')}
                        endFromName="toDateDaily"
                        endFromNameButton={t('general.tags.from')}
                        startDateName="startDateDaily"
                        startDateNameButton={t('general.tags.initHour')}
                        startFromName="fromDateDaily"
                        startFromNameButton={t('general.tags.from')}
                        mimTimeZone={mimTimeZone}
                        refRange={refRange}
                        startDate={startDate}
                        selectedsDays={selectedDays}
                        setSelectedDays={setSelectedDays}
                        type={data.frequency}
                        data={data}
                        errors={errors}
                        input={inputOneDaily}
                        inputSecond={inputSecondDaily}
                        onChange={onChange}
                    />
                break
            case FrequencyEnum.UNIQUE:
                caseFrequency = <Box sx={{ marginBottom: 1, paddingLeft: '4px', paddingRight: '4px' }}>
                    <DateModalRange
                        mimTimeZone={mimTimeZone ?? Constants.defaultTimeZoneObject}
                        defaultErrors={{ from: errors?.from, to: errors?.to }}
                        setDate={(payload) => {
                            onChange({
                                target: {
                                    name: payload.target.name,
                                    value: payload.target.value,
                                }
                            })
                        }}
                        from={data.from}
                        to={data.to ?? null}
                        ref={refRange}
                    />
                </Box>
                break
            case FrequencyEnum.WEEKLY:
                caseFrequency =
                    <FrecuencyInput
                        endDateName="endDate"
                        endDateNameButton={t('general.tags.closingTime')}
                        endFromName="toDateWeekly"
                        endFromNameButton={t('general.tags.to')}
                        startDateName="startDate"
                        startDateNameButton={t('general.tags.openingTime')}
                        startFromName="fromDateWeekly"
                        startFromNameButton={t('general.tags.from')}
                        mimTimeZone={mimTimeZone}
                        refRange={refRange}
                        startDate={startDate}
                        selectedsDays={selectedDays}
                        setSelectedDays={setSelectedDays}
                        type={data.frequency}
                        data={data}
                        errors={errors}
                        input={inputOneWeekly}
                        inputSecond={inputSecondWeekly}
                        onChange={onChange} />
                break
            default:
                caseFrequency = <></>
        }

        return caseFrequency
    }

    const getScheduleType = () => {
        let caseType = <></>
        switch (scheduleType) {
            case ScheduleEnumType.SERIE:
                caseType = getFrecuencyInputs()
                break
            case ScheduleEnumType.UNIQUE:
                caseType = getFrecuencyInputs()
                break
            case ScheduleEnumType.RECURRENT:
                caseType =
                    <SerieInput
                        data={data}
                        errors={errors}
                        mimTimeZone={mimTimeZone}
                        onChange={onChange}
                        refRange={refRange}
                        selectedsDays={selectedDays}
                        startDate={startDate}
                        type={data.frequency}
                        maxToDay={maxToDay}
                    />
                break
            default:
                caseType = <></>
        }
        return caseType
    }

    const getSerieName = () => {
        let serie = '';
        switch (data.frequency) {
            case FrequencyEnum.CYCLIC:
                serie = SerieEnumText.CYCLIC;
                break
            case FrequencyEnum.DAYLI:
                serie = SerieEnumText.DAYLI;
                break
            case FrequencyEnum.WEEKLY:
                serie = SerieEnumText.WEEKLY;
                break
            default:
                serie = ''
        }
        return serie;
    }

    useEffect(() => {
        const newDaysOfWeek = daysOfWeek.filter(day => selectedDays.includes(day.value))
        setInputSecondWeekly(prev => ({ ...prev, dayOfWeek: { ...prev.dayOfWeek, items: newDaysOfWeek } }))
    }, [selectedDays])

    useEffect(() => {
        onChange({ target: { name: 'days', value: '1' } })
    }, [selectedDays])

    const typeScheduling = useMemo(() => itemTypeScheduling({ t }), [])
    return (
        <Box>
            <Box sx={styles.flexGp2}>

                <Box sx={styles.flex}>
                    <Typography variant="text_grey" fontWeight={'bold'} fontSize={16}>{t('schedule.assigned.schedulingType')}</Typography>
                    <SelectActionPlan
                        value={!!data.openQuestionnaire}
                        onChange={(_, value) => {
                            onChange({
                                target: {
                                    name: 'openQuestionnaire',
                                    value: value,
                                },
                            })
                        }}
                        items={typeScheduling}
                        width={100}
                        widthVariable
                    />
                </Box>

                {!data?.openQuestionnaire &&
                    <>
                        <Box sx={styles.flex}>
                            <Typography variant="text_grey" fontWeight={'bold'} fontSize={16}>{t('schedule.assigned.frequency')}</Typography>

                            {scheduleType !== ScheduleEnumType.RECURRENT && <CustomSelect items={scheduleType == ScheduleEnumType.SERIE ? frequenciesWithOuytUnique : frequencies} name="frequency" label={`${t('schedule.scheduleType')} *`} selected={data.frequency} onChange={onChange} errors={errors} isRequired />}

                            {scheduleType == ScheduleEnumType.RECURRENT && <Typography sx={styles.text}>{t('schedule.belongingToSeries', { serie: getSerieName() })}</Typography>}

                            {data.frequency == FrequencyEnum.DAYLI &&
                                <Box sx={styles.containerIcon}>
                                    <Typography>{icons('error')}</Typography>
                                    <Typography>{t('schedule.assigned.frecuencyDailyDescription')}</Typography>
                                </Box>
                            }
                        </Box>

                        <Box sx={styles.flex}>
                            <Typography variant="text_grey" fontWeight={'bold'} fontSize={16}>{scheduleType == ScheduleEnumType.RECURRENT ? t('schedule.assigned.availabilitySchedule') : data.frequency == FrequencyEnum.UNIQUE ? t('schedule.assigned.availabilitySchedule') : t('schedule.assigned.availabilityByCalendar')}</Typography>

                            {getScheduleType()}
                        </Box></>
                }
            </Box>
        </Box>

    )
}

export { ScheduleTypeSerie }
